import { render, staticRenderFns } from "./ContributionsGrid.vue?vue&type=template&id=744e5e01"
import script from "./ContributionsGrid.vue?vue&type=script&lang=ts"
export * from "./ContributionsGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports